import React, { useEffect, useState, useRef } from 'react';
import { HG } from './HG';
import { PlayerHeader, PlayerMain, PlayerWrapper } from './PlayerWrapper';
import { Text } from '@libs/uikit/Components';

const useDuration = (event) => {
    const [duration, setDuration] = useState(0);
    useEffect(() => {
        if (event?.payload?.event === 'AdDurationChange' && event?.payload?.adDuration) {
            setDuration(Math.floor(event.payload.adDuration));
        }
    }, [event]);
    return duration;
};

export const LoopMePlayer = ({ data, onEvent }) => {
    const player = useRef(null);
    const [event, setEvent] = useState(null);
    const [adType, setAdType] = useState('');
    // const [wrapped, setWrapped] = useState('');
    const duration = useDuration(event);
    let duraionString = '00:00';
    duraionString = (Math.floor(duration / 60)).toString().padStart(2, '0') + ':' + (duration % 60).toString().padStart(2, '0');

    const log = (store) => (next) => (action) => {
        setEvent(action);
        next(action);
    };
    const middlewares = [log];

    useEffect(() => {
        if (player.current) {
            const child = player.current.querySelector('#LM_iframe');
            if (child) {
                player.current.removeChild(child);
            }
        }
        var config = {
            containerId: 'loopme_flex_1',
            vastTimeout: 250,
            ads: [
                {
                    type: 'VAST',
                    container: null,
                    isBarsHidden: true,
                    isPortrait: false,
                    shouldBeHovered: false,
                    url: data.value,
                    xml: data.value,
                    autoClose: -1,
                },
            ],
            middlewares,
            user_consent: '%%USER_CONSENT%%',
        };

        window.L.flex.loader.load(config);
    }, [data]);

    useEffect(() => {
        if (event?.payload?.event === 'general') {
            setAdType(event?.payload?.data.vpaid ? 'VPAID' : 'VAST');
        }
        onEvent(event);
    }, [event]);

    return (
        <PlayerWrapper className="player-wrapper__loopme">
            <PlayerHeader>
                preview
                <img src="./assets/image.png" alt="" />
            </PlayerHeader>
            <PlayerMain>
                <div className="ad-wrapper">
                    <div className="ad-container" ref={player}>
                        <div>
                            <div id="loopme_flex_1"></div>
                        </div>
                    </div>
                    <div id="app"></div>
                </div>

                {/* <div className="ad-wrap-info">{wrapped}</div>
                <div className="ad-duration">{duration}</div>
                <div className="ad-type">{adType}</div> */}
            </PlayerMain>
            <HG style={{ margin: '16px 0' }}>
                <Text style={{ flex: 1 }} info>
                    {duration > 0 ? duraionString : null}
                </Text>
                <Text caption>{adType}&nbsp;</Text>
            </HG>
        </PlayerWrapper>
    );
};
